import { useEffect } from 'react';
function useEffectOnce(effect) {
    return useEffect(effect, []);
}
export default useEffectOnce;
//# sourceMappingURL=use-effect-once.js.map